/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class PastMeetingCountEnum.
* @enum {}
* @readonly
*/
export default class PastMeetingCountEnum {
    
        /**
         * value: "1回"
         * @const
         */
        "1回" = "1回";

    
        /**
         * value: "2回"
         * @const
         */
        "2回" = "2回";

    
        /**
         * value: "3回"
         * @const
         */
        "3回" = "3回";

    
        /**
         * value: "それ以上"
         * @const
         */
        "それ以上" = "それ以上";

    

    /**
    * Returns a <code>PastMeetingCountEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/PastMeetingCountEnum} The enum <code>PastMeetingCountEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

